import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';
import { ExpertProfileFragmentFragmentDoc } from '../fragments/expertProfile.fragment.generated';

const defaultOptions = {} as const;
export type ExpertDataQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ExpertDataQuery = {
  __typename?: 'Query';
  expertHubState: {
    __typename?: 'ExpertHubStateType';
    onboardingStep?: string | null;
    onboardingMode?: Types.OnboardingModeEnum | null;
    source?: Types.ExpertHubSourceEnum | null;
    onboardingFinishedAt?: any | null;
    extractionState?: Types.ExpertHubExtractionStateEnum | null;
  };
  expertHubData: {
    __typename?: 'ExpertDataHubType';
    firstName?: string | null;
    lastName?: string | null;
    photoFileId?: string | null;
    cvId?: string | null;
    jobPositionName?: string | null;
    jobPositionId?: string | null;
    rateDesired?: number | null;
    workType?: Types.WorkModeEnum | null;
    location?: string | null;
    availability?: Types.ExpertAvailabilityEnum | null;
    noticeLength?: number | null;
    firstLanguageId?: string | null;
    isOnlyFirstLanguage?: boolean | null;
    isMainRoleExperience?: boolean | null;
    isOtherRolesExperience?: boolean | null;
    avatarUrl?: string | null;
    cv?: {
      __typename?: 'ExpertCvType';
      id: string;
      name: string;
      mimeType: string;
      size: number;
    } | null;
    tags: Array<{ __typename?: 'ExpertTagType'; id: string; weight: number }>;
    manuallyAddedTags: Array<{ __typename?: 'ExpertTagType'; id: string; weight: number }>;
    languages: Array<{
      __typename?: 'ExpertLanguageType';
      languageId: string;
      level: Types.LanguageLevelEnum;
    }>;
    workHistory: Array<{
      __typename?: 'ExpertWorkHistoryHubType';
      id: string;
      jobPositionName: string;
      jobPositionId: string;
      companyName?: string | null;
      tagsIds: Array<string>;
      mainTechnologyIds: Array<string>;
      dateStart: any;
      dateEnd?: any | null;
      isCurrentJob: boolean;
      description?: string | null;
    }>;
    education: Array<{
      __typename?: 'ExpertEducationHubType';
      id: string;
      schoolName: string;
      fieldOfStudyPL?: string | null;
      dateFrom: any;
      dateTo?: any | null;
      isCurrent?: boolean | null;
    }>;
    certificates: Array<{
      __typename?: 'ExpertCertificateHubType';
      id: string;
      name: string;
      issuer?: string | null;
      url?: string | null;
      issueDate?: any | null;
    }>;
  };
};

export const ExpertDataDocument = gql`
  query expertData {
    expertHubState {
      onboardingStep
      onboardingMode
      source
      onboardingFinishedAt
      extractionState
    }
    expertHubData {
      ...ExpertProfileFragment
    }
  }
  ${ExpertProfileFragmentFragmentDoc}
`;

/**
 * __useExpertDataQuery__
 *
 * To run a query within a React component, call `useExpertDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useExpertDataQuery(
  baseOptions?: Apollo.QueryHookOptions<ExpertDataQuery, ExpertDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExpertDataQuery, ExpertDataQueryVariables>(ExpertDataDocument, options);
}
export function useExpertDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ExpertDataQuery, ExpertDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExpertDataQuery, ExpertDataQueryVariables>(
    ExpertDataDocument,
    options,
  );
}
export function useExpertDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ExpertDataQuery, ExpertDataQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExpertDataQuery, ExpertDataQueryVariables>(
    ExpertDataDocument,
    options,
  );
}
export type ExpertDataQueryHookResult = ReturnType<typeof useExpertDataQuery>;
export type ExpertDataLazyQueryHookResult = ReturnType<typeof useExpertDataLazyQuery>;
export type ExpertDataSuspenseQueryHookResult = ReturnType<typeof useExpertDataSuspenseQuery>;
export type ExpertDataQueryResult = Apollo.QueryResult<ExpertDataQuery, ExpertDataQueryVariables>;
export function refetchExpertDataQuery(variables?: ExpertDataQueryVariables) {
  return { query: ExpertDataDocument, variables };
}
